import React from 'react'
import { ResultDisplayProps } from '../../common'
import { AIResultStatus } from '@zocks-communications/client-sdk-js'
import { NoMeetingResult } from '../../DefaultDisplay/View/NoMeetingResult'
import './FamilyTree.scss'
import { FamilyResultView } from './FamilyResultView'
import { useFamilyTreeResult } from './hooks'

export const FamilyTreeCollapsed: React.FC<ResultDisplayProps> = ({ aiResult, collapsed, setCollapsed }) => {
  const familyTreeResults = useFamilyTreeResult(aiResult)

  if (aiResult.status === AIResultStatus.NO_RESULT) {
    return <NoMeetingResult />
  }

  return (
    <div role='button' className='d-flex zocks-gap-2.5 zocks-pr-1.75 zocks-pl-2.0' onClick={() => setCollapsed(!collapsed)}>
      <div className='d-flex gap-2 flex-wrap'>
        {familyTreeResults.map((familyResult, index) => {
          return <FamilyResultView key={`${familyResult.name}_${index}`} familyResult={familyResult} />
        })}
      </div>
    </div>
  )
}
